import { FILTER_NAME } from './duck/constants'

export const TODO_TAB = { id: FILTER_NAME.TO_DO, text: 'omni.hmxklarna.todo.invoice.tab.title' }
export const ALL_TAB = { id: FILTER_NAME.ALL, text: 'omni.hmxklarna.allpurchases.tab.title' }

export const SELECTED_INVOICE_PARAM = 'selectedInvoiceId'

export const APP_DEEP_LINK_PROTOCOL = 'hmgoe'

export enum PossibleOrderStatuses {
  UNPAID = 'UNPAID',
  PAID = 'PAID',
  PART_PAID = 'PART_PAID',
  PAYMENT_SCHEDULED = 'PAYMENT_SCHEDULED',
  PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS',
  PAUSED = 'PAUSED',
}
